module.exports = __webpack_public_path__ + "static/img/lun_10.6a23ec0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_10.jpg
// module id = /CCN
// module chunks = 1